import { render, staticRenderFns } from "./EditScheduledMessage.vue?vue&type=template&id=90273fb0&scoped=true&"
import script from "./EditScheduledMessage.vue?vue&type=script&lang=js&"
export * from "./EditScheduledMessage.vue?vue&type=script&lang=js&"
import style0 from "./EditScheduledMessage.vue?vue&type=style&index=0&id=90273fb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90273fb0",
  null
  
)

export default component.exports